<template>
    <section style="position: relative;">
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
            <div class="col-sm-12 text-right common_save_btn">
            <!-- <router-link :to="{ name: prevRoute.name }"> -->
            <button v-on:click="cancelBtnHandler" class="mr-5 btn btn-default" type="button">
                Cancel
            </button>
            <!-- </router-link> -->
            <button class="mr-2 btn gradientbt" type="submit" @click="createWasteCollectionArea" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                Save
            </button>
            <button class="btn gradientbt mr-5" type="submit" @click="updateWasteCollectionArea" :disabled="!((formstate.$dirty || isAreaLocationEnabled || isAreaNameEnabled) && formstate.$valid)" v-if="$route.params && $route.params._id != '0'">
                Update
            </button>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">
                                {{ flashMessage }}
                            </div>
                        </div>
                    </div>
                    <div id="details" class="common_bdr">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="colmn_inner">
                                <div class="col-sm-12">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                        <div class="form_dierction_msg">
                                            <label>City<span class="requred">*</span></label>
                                            <span>Select your City</span>
                                        </div>
                                        <div class="input_field_validation">
                                        <select required name="cityId" class="form-control" :disabled="($route.params && $route.params._id && $route.params._id != '0') || isCityDisable" v-model="wasteCollectionArea.cityId" v-on:change="getCityLists($event.target.value)">
                                            <option value="" disabled>Select City Name</option>
                                            <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                            </option>
                                        </select>
                                        <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">This is required field</div>
                                        </field-messages>
                                    </div>
                                    </validate>
                                </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="colmn_inner">
                                    <div class="col-sm-12">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.areaName)">
                                            <div class="form_dierction_msg">
                                                <label>Zone Name<span class="requred">*</span></label>
                                                <span>Please fill Your Area Name</span>
                                            </div>
                                            <div class="input_field_validation">
                                            <input maxlength="25" type="text" name="areaName" class="form-control" required v-model="wasteCollectionArea.areaName" @input="areaNameCheck()" placeholder="Zone Name" pattern="^[a-zA-Z]([a-zA-Z0-9 @./#+-_]{0,25}[^\s])*$" />
                                            <field-messages name="areaName" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Zone Name is a required field</div>
                                                <div slot="pattern">
                                                    Alphabets/Numbers/Special Characters are allowed.
                                                </div>
                                            </field-messages>
                                        </div>
                                        </validate>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.segregationId)">
                                        <label>Segregation Plant:</label>
                                        <select name="segregationId" class="form-control" v-model="wasteCollectionArea.segregationId">
                                            <option value="" disabled>Select Segregation Plant</option>
                                            <option v-for="segregationId in segregations" :value="segregationId.id">
                                                {{ segregationId.name }}
                                            </option>
                                        </select>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.transportId)">
                                        <label>Transfer Point:</label>
                                        <select name="transportId" class="form-control" v-model="wasteCollectionArea.transportId">
                                            <option value="" disabled>Select Transfer Point</option>
                                            <option v-for="transportId in transportPoints" :value="transportId.id">{{ transportId.name }}</option>
                                        </select>
                                    </validate>
                                </div>
                            </div>-->
                            <!-- <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.dumpyardId)">
                                        <label>Dump Yard</label>
                                        <select name="dumpyardId" class="form-control" v-model="wasteCollectionArea.dumpyardId">
                                            <option value="" disabled>Select Dump Yard</option>
                                            <option v-for="dumpyardId in dumpyards" :value="dumpyardId.id">
                                                {{ dumpyardId.name }}
                                            </option>
                                        </select>
                                    </validate>
                                </div> -->
    
                                <!-- <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.areaLocation)">
                                        <label>Area Location</label>
                                        <input maxlength="25" type="text" name="areaLocation" class="form-control" v-model="wasteCollectionArea.areaLocation" @input="areaLocatioCheck()" placeholder="Area Location" pattern="^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,25}" />
                                        <field-messages name="areaLocation" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="pattern">
                                                Alphabets/Numbers/Special Characters are allowed.
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div> -->
                            <!-- </div>  -->
                        </vue-form>
                        <!-- v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]" -->
                    </div>
                </div>
            </div>
        </div>
    </section>
    </template>
    
    <script>
    import store from "../../../store";
    import {
        formService,
        eventBus,
        wasteCollectionAreaService,
    } from "../../../services";
    import {
        EVENTS
    } from "../../../config";
    import {
        USER_ROLES
    } from "../../../config";
    import {
        mapState
    } from "vuex";
    import location from "../gmapLocation/location";
    
    export default {
        name: "wasteCollectionAreaCreate",
        components: {
            location,
        },
        data() {
            return {
                isAreaNameEnabled: false,
                isAreaLocationEnabled: false,
                isCityDisable: false,
                prevRoute: null,
                ready: false,
                USER_ROLES: USER_ROLES,
                loading: false,
                flash: false,
                flashType: null,
                flashMessage: "",
                EVENTS: EVENTS,
                formstate: {},
                wasteCollectionArea: {
                    dumpyardId: "",
                    transportId: "",
                    segregationId: "",
                    cityId: "",
                },
                //   wasteCollectionAreaa: {},
                oldWasteCollectionArea: {},
                wasteCollectionAreaId: [],
                transportPoints: {},
                segregations: {},
                dumpyards: {},
                citys: {},
                collectionData: {},
                googleLocation: {},
                coordinates: [],
    
                // userId: this.$route.params._id,
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            });
        },
        mounted: function () {
            this.getCityList();
            eventBus.$on('cityIdChanged', this.onChecked);
            if(this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin"){
                this.isCityDisable = true
                this.wasteCollectionArea.cityId = this.$store.state.auth.cityId.value
            }
        },
        beforeDestroy() {
            eventBus.$off('cityIdChanged', this.onChecked);
        },
        methods: {
            fieldClassName: formService.fieldClassName,
            cancelBtnHandler() {
                if (this.$route.params._id === "0") {
                    this.$router.push({
                        name: "wasteCollectionArea",
                    });
                } else {
                    this.$router.push({
                        name: "wasteCollectionAreaDetails",
                        params: {
                            _id: this.$route.params._id,
                        },
                    });
                }
            },
            onChecked(option){
                this.wasteCollectionArea.cityId = option.value
            },
            getCityList() {
                if (this.$store.state.auth.user.role.key === "cityAdmin" || this.$store.state.auth.user.role.key === "subCityAdmin") {
                    const {
                        _id,
                        cityName
                    } = this.$store.state.auth.user.cityId;
                    this.citys = [{
                        id: _id,
                        name: cityName,
                    }, ];
                    this.wasteCollectionArea["cityId"] = _id;
                    this.getCityLists(_id);
                    this.isCityDisable = true;
                    return;
                }
                this.loading = true;
                const params = {};
                let cityList = [];
                // params.page = 1;
                // params.limit = 999;
                this.$cityRepository
                    .collectionCitysList(params)
                    .then((res) => {
                        this.loading = false;
                        res.data.response.forEach((element) => {
                            if (element.status === true) {
                                cityList.push({
                                    name: element.cityName,
                                    id: element._id,
                                });
                            }
                        });
                        cityList.sort((item1, item2) => {
                            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                        });
                        this.citys = cityList;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("citys.requestFunction-error:", error);
                        this.$snotify.error("Get citys list failed", "Error!");
                    });
            },
    
            getTransportPointList(cityId) {
                this.loading = true;
                const params = {};
                params.$select = ["_id", "transportName"];
                params.isActive = true;
                params.cityId = cityId;
                let transportList = [];
                this.$transportDataRepository
                    .list(params)
                    .then((res) => {
                        this.loading = false;
                        res.data.docs.forEach((element) => {
                            transportList.push({
                                name: element.transportName,
                                id: element._id,
                            });
                        });
                        transportList.sort((item1, item2) => {
                            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                        });
                        this.transportPoints = transportList;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("transportPoints.requestFunction-error:", error);
                        this.$snotify.error("Get transportPoints list failed", "Error!");
                    });
            },
    
            getCityLists(value) {
                this.wasteCollectionArea.segregationId = "";
                this.wasteCollectionArea.transportId = "";
                this.wasteCollectionArea.dumpyardId = "";
    
                this.getTransportPointList(value);
                this.getDumpYardList(value);
                this.getSegregationPlantList(value);
            },
    
            getSegregationPlantList(cityId) {
                this.loading = true;
                const params = {};
                params.$select = ["_id", "plantName"];
                params.isActive = true;
                params.cityId = cityId;
                let segregationList = [];
    
                this.$segregationDataRepository
                    .list(params)
                    .then((res) => {
                        this.loading = false;
    
                        res.data.docs.forEach((element) => {
                            // if (element.isActive === true && element.cityId === cityId) {
                            segregationList.push({
                                name: element.plantName,
                                id: element._id,
                            });
                            // }
                        });
    
                        segregationList.sort((item1, item2) => {
                            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                        });
    
                        this.segregations = segregationList;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("segregations.requestFunction-error:", error);
                        this.$snotify.error("Get segregations list failed", "Error!");
                    });
            },
            getDumpYardList(cityId) {
                this.loading = true;
                const params = {};
                params.$select = ["_id", "dumpYardName"];
                params.isActive = true;
                params.cityId = cityId;
                let dumpYardList = [];
                this.$dumpyardDataRepository
                    .list(params)
                    .then((res) => {
                        this.loading = false;
                        res.data.docs.forEach((element) => {
                            // if (element.isActive === true && element.cityId === cityId) {
                            dumpYardList.push({
                                name: element.dumpYardName,
                                id: element._id,
                            });
                            // }
                        });
                        dumpYardList.sort((item1, item2) => {
                            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                        });
                        this.dumpyards = dumpYardList;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("DumpYard.requestFunction-error:", error);
                        this.$snotify.error("Get DumpYard list failed", "Error!");
                    });
            },
    
            createWasteCollectionArea() {
                this.loading = true;
                this.collectionData = {};
                let area = {};
                // this.wasteCollectionArea['areaLocation'] = this.googleLocation.name
                // this.wasteCollectionArea['wasteAreaGeoLocation'] = this.coordinates
                // this.wasteCollectionArea["userId"] = store.state.auth.user._id.toString();
                area["userId"] = store.state.auth.user._id.toString();
                area["areaName"] = this.wasteCollectionArea.areaName
                area["cityId"] = this.wasteCollectionArea.cityId
                // if (this.wasteCollectionArea.dumpyardId) {
                //     area["dumpyardId"] = this.wasteCollectionArea.dumpyardId
                // }
                if (this.wasteCollectionArea.segregationId) {
                    area["segregationId"] = this.wasteCollectionArea.segregationId
                }
                if (this.wasteCollectionArea.transportId) {
                    area["transportId"] = this.wasteCollectionArea.transportId
                }
                if (this.wasteCollectionArea.areaLocation) {
                    area["areaLocation"] = this.wasteCollectionArea.areaLocation
                }
    
                return wasteCollectionAreaService
                    .addWasteCollectionArea(area)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.$snotify.success(
                            `The ${this.wasteCollectionArea.areaName} has been added successfully.`
                        );
                        this.$router.push("/wasteCollectionArea");
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.data.message.includes("Duplicate")) {
                            var errorMessage = "This wasteCollectionArea name already exist";
                            this.$snotify.error(errorMessage, "Error!");
                        }
                        if (error.data.message == "This area name already exist") {
                            this.$snotify.error(error.data.message, "Error!");
                        }
                    });
            },
    
            updateWasteCollectionArea() {
                this.loading = true;
    
                this.collectionData = {};
                let area = {};
                // if (this.wasteCollectionArea.dumpyardId) {
                //     area["dumpyardId"] = this.wasteCollectionArea.dumpyardId
                // }
                if (this.wasteCollectionArea.segregationId) {
                    area["segregationId"] = this.wasteCollectionArea.segregationId
                }
                if (this.wasteCollectionArea.transportId) {
                    area["transportId"] = this.wasteCollectionArea.transportId
                }
                if (this.wasteCollectionArea.areaLocation) {
                    area["areaLocation"] = this.wasteCollectionArea.areaLocation
                }
                area["areaName"] = this.wasteCollectionArea.areaName
                area["cityId"] = this.wasteCollectionArea.cityId
                area["userId"] = store.state.auth.user._id.toString();
                area["_id"] = this.details._id;
                return wasteCollectionAreaService
                    .updateWasteCollectionArea(area)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.$snotify.success(
                            `The ${this.wasteCollectionArea.areaName} has been Updated successfully.`
                        );
                        // this.$router.push("/wasteCollectionArea");
                        this.cancelBtnHandler();
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.data.message.includes("Duplicate")) {
                            var errorMessage = "This wasteCollectionArea name already exist";
                            this.$snotify.error(errorMessage, "Error!");
                        }
                        if (error.data.message == "This area name already exist") {
                            this.$snotify.error(error.data.message, "Error!");
                        }
                    });
            },
    
            clearChanges() {
                this.wasteCollectionArea = _.cloneDeep(this.oldWasteCollectionArea);
                this.formstate._reset();
            },
            updateSegregationPlant() {
                this.loading = true;
                this.wasteCollectionArea.wasteCollectionAreaId = this.$route.params._id;
    
                return wasteCollectionAreaService
                    .updateWasteCollectionArea(
                        this.wasteCollectionArea,
                        this.oldWasteCollectionArea
                    )
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.formstate._reset();
                        this.oldWasteCollectionArea = _.cloneDeep(this.wasteCollectionArea);
                        this.$snotify.success("wasteCollectionArea updated", "Success!");
                        this.$router.push("/wasteCollectionArea");
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error(
                            "wasteCollectionArea.updatewasteCollectionArea-error:",
                            error
                        );
                        this.$snotify.error("Update wasteCollectionArea failed", "Error!");
                        if (error.data.message.includes("must be one of")) {
                            this.flash = true;
                            this.flashType = "error";
                            this.flashMessage =
                                "That wasteCollectionArea name is not allowed. You must first update the list of allowed wasteCollectionArea names" +
                                " in the appy client and server config.";
                        }
                    });
            },
            getWasteCollectionArea() {
                this.loading = true;
                return wasteCollectionAreaService
                    .getwasteCollection(this.$route.params._id)
                    .then((response) => {
                        this.details = response.data.response;
                        this.getCityLists(this.details.cityId._id);
                        this.wasteCollectionArea["areaName"] = this.details.areaName;
                        this.wasteCollectionArea["cityId"] = this.details.cityId != null ? this.details.cityId._id : '';
                        this.wasteCollectionArea["dumpyardId"] = this.details.dumpyardId != null ? this.details.dumpyardId._id : '';
                        this.wasteCollectionArea["segregationId"] = this.details.segregationId != null ? this.details.segregationId._id : '';
                        this.wasteCollectionArea["transportId"] = this.details.transportId != null ? this.details.transportId._id : '';
                        this.wasteCollectionArea["areaLocation"] = this.details.areaLocation;
    
                        this.oldUser = _.cloneDeep(this.user);
                        this.$store.dispatch(
                            "setBreadcrumbTitle",
                            this.wasteCollectionArea.areaName
                        );
    
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("UserDetails.updateUser-error:", error);
                        this.$snotify.error("Update user failed", "Error!");
                    });
            },
    
            areaNameCheck() {
                this.isAreaNameEnabled = true;
            },
    
            areaLocatioCheck() {
                this.isAreaLocationEnabled = true;
            }
    
            // onCancel(){
            //     this.$router.push({
            //     name: 'wasteCollectionAreaDetails',
            //     params: {
            //       _id: this.$route.params.wcaId,
            //     },
            //   });
            // }
        },
        created() {
            eventBus.$on("geoLocation", (location) => {
                this.googleLocation = location;
                let locationinfo = Object.values(this.googleLocation);
                this.coordinates = locationinfo.splice(0, 2);
            });
            const promises = [];
            this.loading = true;
            // promises.push(this.getManagers());
            if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
                promises.push(this.getWasteCollectionArea());
            }
            Promise.all(promises)
                .then(() => {
                    this.loading = false;
                    this.ready = true;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        beforeDestroy() {},
    
        fieldClassName: function (field) {
            if (!field) {
                return "";
            }
            if ((field.$touched || field.$submitted) && field.$valid) {
                return "has-success";
            }
            if ((field.$touched || field.$submitted) && field.$invalid) {
                return "has-danger";
            }
        },
    
        // computed: {
        //     ...mapState({
        //         user: state => state.auth.user,
        //     })
        // }
    };
    </script>
    
    <style scoped>
    .required-field>label::after {
        content: "*";
        color: red;
        margin-left: 0.25rem;
    }
    .requred{
        color: red;
    }
   
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    
    .has-danger {
        color: red;
    }
    
    .mt {
        margin-top: 7px;
    }
    
    .gradientbt {
        background: #3085d6;
        color: white;
    }
    
    .form-group {
        display: flex;
        align-items: center;
    }
    
    /* .form-group label{
        flex: 0 0 50%;
    } */
    
    .common_save_btn {
        position: absolute;
        top: -45px;
    }
    
    .input_field_validation {
        display: flex;
        flex-direction: column;
        flex: 0 0 60%;
    }
    
    .form_dierction_msg {
        flex: 0 0 30%;
        display: flex;
        flex-direction: column;
    
    }
    /* .scroll{
    
        height: 300px;
        overflow: auto;
    } */
    </style>


// WEBPACK FOOTER //
// wasteCollectionAreaCreate.vue?2dca541a